/**
 * URLs canónicos por rota. Cada língua é servida numa pasta própria
 * (/, /en/, /uk/, …) e o Vite expõe essa base em BASE_URL, por isso o
 * canonical de /en/o-que-fazer sai certo sem código por língua.
 */
export const SITE_URL = 'https://traficopessoas.apav.pt'

export const pageUrl = (slug = '') => `${SITE_URL}${import.meta.env.BASE_URL}${slug}`
